import App from '../App'

// 首页
const index = r => require.ensure([], () => r(require('@/page/index')), 'index')

// 章节
const chapter = r =>
  require.ensure([], () => r(require('@/page/chapter')), 'chapter')

// 内容
const details = r =>
  require.ensure([], () => r(require('@/page/details')), 'details')

// 非剧情按钮
const nonDramatic = r =>
  require.ensure([], () => r(require('@/page/nonDramatic')), 'nonDramatic')

// 隐藏任务
const hiddenTask = r =>
  require.ensure([], () => r(require('@/page/hiddenTask')), 'hiddenTask')

// 成就
const achievement = r =>
  require.ensure([], () => r(require('@/page/achievement')), 'achievement')

// 排行榜
const ranking = r =>
  require.ensure([], () => r(require('@/page/ranking')), 'ranking')

// 设置
const setting = r =>
  require.ensure([], () => r(require('@/page/setting')), 'setting')

// 测试
const test = r => require.ensure([], () => r(require('@/page/test')), 'test')

export default [
  {
    path: '/',
    component: App, // 顶层路由，对应index.html
    children: [
      {
        path: '/',
        name: 'index',
        component: index
      },
      {
        path: '/chapter',
        name: 'chapter',
        component: chapter
      },
      {
        path: '/details',
        name: 'details',
        component: details
      },
      {
        path: '/nonDramatic',
        component: nonDramatic,
        children: [
          {
            path: '/hiddenTask',
            name: 'hiddenTask',
            component: hiddenTask
          },
          {
            path: '/achievement',
            name: 'achievement',
            component: achievement
          },
          {
            path: '/ranking',
            name: 'ranking',
            component: ranking
          },
          {
            path: '/setting',
            name: 'setting',
            component: setting
          }
        ]
      },
      {
        path: '/test',
        name: 'test',
        component: test
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js